<template>
  <div class="my-matches" v-if="lobbies.length > 0">
    <h2 class="title-lined">
      <div class="title-line">minhas partidas agendadas</div>
    </h2>

    <div class="featured-matches-container">
      <div :class="`match-small-box ${lobby.status} ${lobby.map}`" v-for="lobby in lobbies" :key="lobby.id">
        <div class="header">
          <span>{{ lobby.start_time_friendly }}</span>
        </div>
        <div class="team_a">
          <div v-if="lobby.is_pug" :class="`team-column ${lobby.winner == 'team1' && lobby.team1_score >= 16 ? 'winner' : ''}`">
            <span class="team-score">{{ lobby.team1_score }}</span>
            <span class="team-name">{{ lobby.team1_name }}</span>
          </div>
          <div v-else :class="`team-column ${lobby.winner == 'team1' && lobby.team1_score >= 16 ? 'winner' : ''}`">
            <span class="team-score">{{ lobby.team1_score }}</span>
            <span class="team-name">{{ lobby.team_a.name }}</span>
          </div>
        </div>
        <div class="versus">
          x
        </div>
        <div class="team_b">
          <div v-if="lobby.is_pug" :class="`team-column ${lobby.winner == 'team2' && lobby.team2_score >= 16 ? 'winner' : ''}`">
            <span class="team-score">{{ lobby.team2_score }}</span>
            <span class="team-name">{{ lobby.team2_name }}</span>
          </div>
          <div v-else :class="`team-column ${lobby.winner == 'team2' && lobby.team2_score >= 16 ? 'winner' : ''}`">
            <span class="team-score">{{ lobby.team2_score }}</span>
            <span class="team-name">{{ lobby.team_b.name }}</span>
          </div>
        </div>
        <div class="footer">
          <router-link :to="{ name: 'LobbySingle', params: { id: lobby.id }}">
            ver partida
          </router-link>
          <router-link :to="{ name: 'RoomSingle', params: { id: lobby.id }}">
            ir para lobby
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'MyMatches',
  computed : {
  },
  data () {
    return {
      user: { avatar: { url: '' } },
      lobbies: []
    }
  },
  methods: {
    initialize() {
      this.$http
          .get(`my_matches.json`)
          .then(response => (this.lobbies = response.data))
    }
  },
  mounted () {
    this.initialize()
  },
  components: {
  }
}
</script>

<style scoped lang="sass">
.my-matches
  margin: 20px 0 40px

  .featured-matches-container
    display: flex
    flex-wrap: wrap
    // overflow: hidden
    // justify-content: space-around
    .match-small-box
      width: 100%
      height: 90px
      background: rgba(255, 255, 255, 1)

      margin-bottom: 10px

      display: grid
      grid-gap: 3px
      grid-template-columns: 46% 6% 46%
      grid-template-rows: 1fr 1fr 1fr
      
      grid-template-areas: "header header header" "team_a versus team_b" "footer footer footer"

      font-size: 12px
      color: white

      border-radius: 4px
      padding: 4px
      position: relative
      text-decoration: none

      * 
        -webkit-font-smoothing: antialiased
        -moz-osx-font-smoothing: grayscale

      @keyframes pulseLive
        0%
          opacity: .8
          box-shadow: 0 0 0 1px lighten(red, .8)
        50%
          box-shadow: none
          opacity: 1
        100%
          opacity: .8
          box-shadow: 0 0 0 1px lighten(red, .8)

      &.live:after 
        content: ''
        height: 5px
        width: 5px
        background: red
        position: absolute
        top: 11px
        left: 10px
        border-radius: 100%
        animation: pulseLive .8s ease infinite
      
      &.live:before
        content: 'LIVE'
        color: white
        font-family: 'Oswald', monospace
        font-size: 9px
        position: absolute
        top: 7px
        left: 20px
        
      &.idle:after 
        content: ''
        height: 5px
        width: 5px
        background: red
        position: absolute
        top: 11px
        left: 10px
        border-radius: 100%
        animation: pulseLive .8s ease infinite
      
      &.idle:before
        content: 'PARTIDA LIBERADA'
        color: white
        font-family: 'Oswald', monospace
        font-size: 9px
        position: absolute
        top: 7px
        left: 20px
      
      &.ended:after 
        content: ''
        height: 5px
        width: 5px
        background: rgba(255, 255, 255, .4)
        position: absolute
        top: 11px
        left: 10px
        border-radius: 100%
      
      &.ended:before
        content: 'ENCERRADO'
        color: rgba(255, 255, 255, .4)
        font-family: 'Oswald', monospace
        font-size: 9px
        position: absolute
        top: 7px
        left: 20px
      
      &:hover 
        transform: scale(1.03)
        transition: all 0.2s ease


      .header
        grid-area: header
        text-align: center
        // display: none
      .versus
        grid-area: versus
        text-align: center
        display: flex
        align-items: center
        font-weight: bold
        justify-content: center
      .team_a
        grid-area: team_a
        text-align: right
        display: flex
        justify-content: flex-end
        align-items: center
        .team-name
          text-overflow: ellipsis
          white-space: nowrap
          overflow: hidden
          height: 14px
        
      .team_b
        grid-area: team_b
        display: flex
        justify-content: flex-start
        align-items: center
      
      .team-score
          display: block
          font-weight: bold
          font-size: 18px
          font-family: 'Oswald', monospace
          margin-bottom: -4px
          
          
      .footer
        grid-area: footer
        text-align: center
        a
          display: inline-block
          color: white
          font-weight: bold

          &:not(:last-child)
            margin-right: 10px
          

  .stats-table
    table
      td
        padding: 0.25em 0.45em
        font-size: 14px
        &:last-of-type
          text-align: center
          a
            display: block
            font-size: 13px
            &:hover
              text-decoration: underline
              font-weight: bold
    a
      color: #008EB4

    .versus-header
      text-align: center
    .versus-column
      text-align: center
      span
        display: block
        font-size: 12px
        background: green
        color: white
        padding: 3px 5px
        border-radius: 4px
    .team-header
      text-align: center
    .team-column
      text-align: center
      &.winner
        color: green
        font-weight: bold
    .team-score
      text-align: center
      display: block
    .lobby-size
      display: block
</style>
